import type React from 'react'
import { createContext } from 'react'

import { type components } from '../configs/schema'

export interface ExplanationContextType {
  visible: boolean
  explanationLoading: boolean
  data?: components['schemas']['APILatestExplanation']
  setVisible: (visible: boolean) => void
  setExplanationLoading: (loading: boolean) => void
  setExplanationData: React.Dispatch<
    React.SetStateAction<
      components['schemas']['APILatestExplanation'] | undefined
    >
  >
}

export const ExplanationContext = createContext<ExplanationContextType>(
  undefined!,
)
